<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar" @close="cancelar">
    <b-card no-body>
      <b-card bg-variant="light">
        <b-form-row>
          
          <lg-finder-page-subgrupo-produto  id="finderSubgrupoProdutoPelaClasse" @onSelect="selectSubgrupoProduto"
            :prefix="prefix + title + ' > '" invalidFeedback="Informe um Subgrupo de Produto"
            v-model="form.subgrupoProduto" :disabled="disabled || (subgrupo && subgrupo.id > 0)" readonly :showClear="false" ></lg-finder-page-subgrupo-produto>
        </b-form-row>

        <b-form-row>
          <lg-form-input invalidFeedback="Descrição deve ser informada!" description="" :error="$v.form.descricao"
            v-model="form.descricao" label="Descrição: *" lg="12" sm="7" md="10" />
        </b-form-row>

        <b-form-row>
          <lg-form-input invalidFeedback="Número deve ser informado" description="" :error="$v.form.numero"
            v-model="form.numero" label="Número: *" lg="12" sm="7" md="4" />
        </b-form-row>

        <b-form-row>
          <b-form-group label="Status:" class="text-left ml-1">
            <b-form-radio-group v-model="form.situacao" class="d-inline-block">
              <b-form-radio :value="1">Ativo</b-form-radio>
              <b-form-radio :value="0">Inativo</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <div class="d-flex justify-content-center align-items-center w-100">
            <b-button type="submit" variant="success" style="height: 20px" pill size="sm" @click="save">
              <div class="btn-size-alinhamento">
                <b-icon icon="check-circle" />
              </div>
            </b-button>
            <b-button class="ml-2" @click="cancelar" variant="danger" style="height: 20px" pill size="sm">
              <div class="btn-size-alinhamento">
                <b-icon icon="x-circle" />
              </div>
            </b-button>
          </div>
        </b-form-row>
      </b-card>
    </b-card>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import required from "vuelidate/lib/validators/required"
import { FormResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm"
import ClasseService from "@/core/api/ClasseService"

export default {
  name: "ClasseForm",
  components: {
    LgFinderPageSubgrupoProduto: ()=> import ("@/components/Finders/LgFinderPageSubgrupoProduto.vue"),
    LgFormInput,
  },

  mixins: [FormResourceMixin, ConfirmMixin],

  props: {
    id: Number,
    onselect: Function,
    user: Object,
    disabled: {
      type: Boolean,
      default: true,
    },
    value: [Number, String],
    prefix: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Subgrupo*:",
    },
    subgrupo: {},
  },

  validations: {
    form: {
      subgrupoProduto: { required },
      descricao: { required },
      numero: { required },
    },
  },

  computed: {
    formIsValid() {
      return !this.$v.$invalid
    },
  },

  data() {
    return {
      showModal: true,
      title: " Cadastro",
      localValue: this.value,
      isBusy: false,
      form: {
        subgrupoProduto: {},
        descricao: "",
        numero: null,
        situacao: 1,
      },
    }
  },

  beforeMount() {
    this.$ClasseService = new ClasseService()
  },

  async mounted() {
    if (this.id) {
      await this.$ClasseService
        .findById(this.id)
        .then(response => {
          this.form = response.data
          this.form.subgrupoProduto = response.data.subgrupoProduto
        })
        .finally(() => {
          this.isBusy = false
        })
    }
    if (this.subgrupo) {
      this.form.subgrupoProduto = this.subgrupo
    }
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    },
    localValue(newValue) {
      this.$emit("input", newValue)
    },
  },

  methods: {
    selectSubgrupoProduto(subgrupoProduto) {
      this.form.subgrupoProduto = subgrupoProduto
    },

    cancelar() {
      this.$emit("close")
    },

    async save() {
      if (!this.formIsValid) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        })
        return
      }
      try {
        await this.$ClasseService.save(this.form).then(response => {
          if (
            response.status === 200 ||
            response.status === 201 ||
            response.status === 204
          ) {
            this.$notify({
              type: "success",
              message: "Cadastro salvo com sucesso!",
            })

            this.$emit("close")
          } else {
            this.$notify({
              type: "danger",
              message:
                "Ocorreu um erro ao salvar o cadastro. Verifique se já existe uma classe com o mesmo número.",
            })
          }
        })
      } catch (e) {
        this.$notify({
          type: "danger",
          message: "Ocorreu um erro ao salvar o cadastro.",
        })
      }
    },
  },
}
</script>
